module.exports = __webpack_public_path__ + "static/media/IMG_1094.e2eb8de4.jpg";